export default "<section class=\"boxConteudo\">\n\t\t\t<div class=\"boxContainer\">\n\t\t\t <div app-grid-registro-acoes></div>\n\t\t</div>\n\t</section>"